"use client";

import { animated } from "@faire/deprecated-retailer-visitor-shared/components/GhostLoading/animated";
import { LoadingSpinner } from "@faire/slate/components/loading-spinner";
import { Core } from "@faire/slate/foundation/color";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import React from "react";
import styled, { css } from "styled-components";

const HEIGHT_ADJUST = 78;

export const ErrorRow = styled(Row).attrs({ align: "center" })`
  position: relative;
  margin: 50px;
  padding: 20px;
  border-top: 1px solid ${Core.border.muted};
  border-bottom: 1px solid ${Core.border.muted};
`;
ErrorRow.displayName = "ErrorRow";

// eslint-disable-next-line @faire/prefer-slate-attrs -- why is this a Row if we are doing display: block?
export const BlockInheritRow = styled(Row).attrs({ align: "center" })`
  &&& {
    display: block;
  }
  position: inherit;
  width: 100%;
`;

const CarouselFallBackWrapper = styled.div<{ $height: number }>`
  height: ${(props) => props.$height}px;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
`;

export const CarouselFallback = () => {
  const carouselHeight = useResponsiveValue({
    mobileAndAbove: 236,
    tabletAndAbove: 260,
    desktopAndAbove: 413,
  });
  return (
    <CarouselFallBackWrapper
      className="chromatic-ignore"
      $height={carouselHeight}
    >
      <LoadingSpinner size="xLarge" />
    </CarouselFallBackWrapper>
  );
};

export const RelatedSearchTermFallbackWrapper = styled(Column).attrs({
  align: "center",
  justify: "center",
})<{
  $searchTermContainerHeightMobile: number;
  $searchTermContainerHeightTabletAbove: number;
}>`
  height: ${(props) =>
    props.$searchTermContainerHeightTabletAbove + HEIGHT_ADJUST}px;
  border-top: 1px solid ${Core.border.muted};
  margin-top: 30px;
  ${responsiveMediaQueries.mobile} {
    height: ${(props) =>
      props.$searchTermContainerHeightMobile + HEIGHT_ADJUST}px;
  }
`;

const NoResultsArea = styled(Column).attrs({
  align: "center",
  justify: "center",
})`
  padding: ${getSpacing(36, "2x", "6x")};
  width: 100%;
  text-align: center;

  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing(20, "2x", "4x")};
  }
`;

export const AnimatedNoResults = animated(NoResultsArea)({
  initialStyle: css`
    opacity: 0;
  `,
  loadedStyle: css`
    opacity: 1;
  `,
});
